<template>
  <div class="page-content">
    <el-row class="operator-btns">
      <el-button @click="goBack">返回</el-button>
      <el-button type="primary" @click="confirmHandle">{{ atId ? '编辑品类信息' : '确定并添加该品类' }}</el-button>
    </el-row>
    <el-tabs type="border-card" class="form-container">
      <el-tab-pane label="基本信息">
        <el-form ref="ruleForm" :model="form" label-width="120px" class="form-content">
          <el-form-item prop="language" label="语言">
            <el-select :disabled="!!atId" @change="appUnmarkedCategoryParentListHandle" v-model="form.language"
              placeholder="请选择语言">
              <el-option v-for="item in languageOpts" :key="item.language" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <div class="category-part" v-for="(category, parentIndex) in form.columnBatchAddParamList" :key="parentIndex">
            <span class="part-index">{{ parentIndex + 1 }}</span>
            <div class="category-left">
              <el-form-item prop="columnName" label="app品类名称">
                <el-input v-model="category.columnName" placeholder="请输入app品类名称" maxlength="30"
                  show-word-limit></el-input>
              </el-form-item>

              <el-form-item label="下属品类" prop="categoryAddParam">
                <div class="categorys">
                  <div class="category-bottom" v-for="(childItem, index) in category.categoryAddParam" :key="index">
                    <div class="left">
                      <el-input placeholder="序号"
                        @input="categoryNumberInput(childItem.categoryNumber, parentIndex, index)" maxlength="2"
                        v-model="childItem.categoryNumber">
                      </el-input>
                    </div>
                    <div class="center">
                      <el-select v-model="childItem.categoryId" placeholder="请选择所属品类"
                        @change="e => categoryChange(e, parentIndex, index)">
                        <el-option v-for="threeItem in category.unmarkedCategoryParentOpts" :key="threeItem.categoryId"
                          :label="threeItem.categoryName" :disabled="threeItem.disabled" :value="threeItem.categoryId">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="right">
                      <el-button type="danger" icon="el-icon-delete" circle v-if="category.categoryAddParam.length != 1"
                        @click="delHandle(childItem, parentIndex, index)"></el-button>
                      <el-button type="primary" icon="el-icon-plus" v-if="category.categoryAddParam.length - 1 == index"
                        circle @click="addHandle(parentIndex)"></el-button>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="category-right" v-if="!atId">
              <el-button type="danger" icon="el-icon-delete" circle @click="delPartHandle(parentIndex)"
                v-if="form.columnBatchAddParamList.length != 1"></el-button>
              <el-button type="primary" icon="el-icon-plus" circle @click="addPartHandle(parentIndex)"></el-button>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
let that;
import { listAppUnmarkedCategory, batchAddAppColumn, getAppColumnDetail, removeCategory, addCategory, editAppColumn } from '@/api/appCategory'
export default {
  data() {
    return {
      languageOpts: [{
        value: 0,
        label: '中文'
      }, {
        value: 1,
        label: '英文'
      }],
      atId: '',
      form: {
        language: 0,
        columnBatchAddParamList: []
      },
      unmarkedCategoryParentOpts: []
    }
  },
  created() {
    that = this;
    let atId = this.$route.query.atId;
    if (atId) {
      this.atId = atId;
      this.getAppColumnDetailHandle(atId, () => {
        this.appUnmarkedCategoryParentListHandle((list) => {
          let curent = this.form.columnBatchAddParamList[0];
          curent.unmarkedCategoryParentOpts = list;
          this.updateSelect(0);
        });
      });
    } else {
      this.addPartHandle();
      this.appUnmarkedCategoryParentListHandle((list) => {
        let curent = this.form.columnBatchAddParamList[0];
        curent.unmarkedCategoryParentOpts = list;
        this.unmarkedCategoryParentOpts = JSON.parse(JSON.stringify(list)); // 新增的时候才有
        this.updateSelect(0);
      });
    }
  },
  methods: {
    // 更新当前品类的未选中的品类
    updateSelect(partIndex) {
      let currentPart = this.form.columnBatchAddParamList[partIndex];
      
      let selectedIds = currentPart.categoryAddParam.map(item => item.categoryId);
      let opts = currentPart.unmarkedCategoryParentOpts.map(item => {
        item.disabled = selectedIds.indexOf(item.categoryId) != -1;
        return item;
      })
      currentPart.unmarkedCategoryParentOpts = [...opts];
      this.$set(this.form.columnBatchAddParamList, partIndex, currentPart);
    },
    // 下属品类序号输入
    categoryNumberInput(e, parentIndex, index) {
      let nums = Number(e.replace(/\D/g, ""));
      let current = this.form.columnBatchAddParamList[parentIndex];
      let categoryAddParam = current.categoryAddParam;
      categoryAddParam[index].categoryNumber = nums || index + 1;
    },
    // 下属品类改变的时候
    categoryChange(categoryId, parentIndex, index) {
      if (this.atId) {
        let current = this.form.columnBatchAddParamList[parentIndex];
        let categoryAddParam = current.categoryAddParam[index];
        // 改变的时候保存
        let params = {
          atId: this.atId,
          categoryId,
          categoryNumber: categoryAddParam.categoryNumber
        }
        addCategory({
          params
        }).then(res => {
          this.updateSelect(parentIndex);
        })
      } else {
        
        this.updateSelect(parentIndex);
      }
    },
    // 获取详情
    getAppColumnDetailHandle(atId, callbadk) {
      getAppColumnDetail({
        params: {
          atId
        }
      }).then((res) => {
        let { atId, categoryDetailVos, columnName, language } = res.data.data;
        
        if (categoryDetailVos.length == 0) {
          categoryDetailVos = [{
            categoryNumber: 1,
            categoryId: ''
          }]
        }
        let categoryPart = {
          columnName,
          categoryAddParam: categoryDetailVos
        }
        this.atId = atId;
        this.form = {
          language,
          columnBatchAddParamList: [categoryPart]
        }
        if (callbadk) {
          callbadk();
        }
      })
    },
    // 增加App品类模块
    addPartHandle() {
      let categoryPart = {
        columnName: '',
        unmarkedCategoryParentOpts: [...this.unmarkedCategoryParentOpts],
        categoryAddParam: [{
          categoryNumber: 1,
          categoryId: ''
        }]
      }
      this.form.columnBatchAddParamList.push(categoryPart)
    },
    // 删除App品类模块
    delPartHandle(index) {
      this.form.columnBatchAddParamList.splice(index, 1);
    },
    // 获取未标记的下属品类
    appUnmarkedCategoryParentListHandle(callback) {
      listAppUnmarkedCategory({
        params: {
          language: this.form.language
        }
      }).then(res => {
        let data = res.data.data;
        if (Array.isArray(data)) {
          if (!this.atId) {
            this.form.columnBatchAddParamList = [{
              columnName: '',
              unmarkedCategoryParentOpts: [...data],
              categoryAddParam: [{
                categoryNumber: 1,
                categoryId: ''
              }]
            }]
            this.unmarkedCategoryParentOpts = JSON.parse(JSON.stringify(data));
          }
          callback(res.data.data)
        } else {
          callback([])
        }
      })
    },
    // 删除子品类
    delHandle(item, parentIndex, index) {
      let { atId } = this;
      if (atId) {
        if (!item.categoryId) {
          let current = this.form.columnBatchAddParamList[parentIndex];
          current.categoryAddParam.splice(index, 1);
          this.$set(this.form.columnBatchAddParamList, parentIndex, current);
          return;
        }
        let params = {
          categoryId: item.categoryId,
          atId
        }
        removeCategory({
          params
        }).then(res => {
          if (res.data.code == 200) {
            let current = this.form.columnBatchAddParamList[parentIndex];
            current.categoryAddParam.splice(index, 1);
            this.$set(this.form.columnBatchAddParamList, parentIndex, current);
            this.updateSelect(parentIndex);
          }
        })
      } else {
        let current = this.form.columnBatchAddParamList[parentIndex];
        current.categoryAddParam.splice(index, 1);
        this.$set(this.form.columnBatchAddParamList, parentIndex, current);
        this.updateSelect(parentIndex);
      }
    },
    // 新增子模块的下属品类
    addHandle(index) {
      let current = this.form.columnBatchAddParamList[index];
      current.categoryAddParam.push({
        categoryNumber: current.categoryAddParam.length + 1,
        categoryId: '',
      })
      this.$set(this.form.columnBatchAddParamList, index, current);
    },
    // 批量新增或编辑
    confirmHandle() {
      let errorMsg = '';
      this.form.columnBatchAddParamList.forEach((itemJ, indexJ) => {
        let { categoryAddParam, columnName } = itemJ;
        if (!columnName) {
          if (!errorMsg) {
            errorMsg = `第${indexJ + 1}个品类，品类名称为空`
          }
        }
        categoryAddParam.forEach((itemk, indexK) => {
          let { categoryNumber, categoryId } = itemk;
          if (!categoryNumber) {
            if (!errorMsg) {
              errorMsg = `第${indexJ + 1}个品类，第${indexK + 1}个下属品类，序号为空`
            }
          }
          if (!categoryId) {
            if (!errorMsg) {
              errorMsg = `第${indexJ + 1}个品类，第${indexK + 1}个下属品类，未选择所属品类`
            }
          }
        })
      })
      if (errorMsg) {
        this.$message.error(errorMsg);
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.atId ? '是否确定修改该品类' : '是否确定添加该品类', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (this.atId) {
              let columnName = this.form.columnBatchAddParamList[0]['columnName'];
              let params = {
                columnName,
                atId: this.atId
              }
              editAppColumn({
                params
              }).then(res => {
                this.goBack();
              })
            } else {
              batchAddAppColumn({
                params: this.form
              }).then(res => {
                this.goBack();
              })
            }
          })
        }
      });
    },
    // 返回上一页
    goBack() {
      window.history.go(-1);
    }
  }
}
</script>

<style lang='less' scoped>
.page-content {
  padding-bottom: 60px !important;

  .form-container {
    margin-top: 20px;

    .form-content {
      width: 800px;

      .category-part {
        display: flex;
        margin-bottom: 20px;
        border-radius: 10px;
        position: relative;

        .part-index {
          position: absolute;
          padding: 6px;
          background-color: #409EFF;
          color: #fff;
          font-size: 14px;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }

        .category-left {
          padding: 20px 20px 20px 0;
          border: 1px solid #f1f1f1;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          flex: 0 0 700px;

          .categorys {
            .category-bottom {
              display: flex;
              margin-bottom: 10px;

              .left {
                flex: 0 0 80px;
              }

              .center {
                flex: 1;
                margin: 0 10px;

                .el-select {
                  width: 100% !important;
                }
              }

              .right {
                width: 100px;
                text-align: left;
              }
            }
          }
        }

        .category-right {
          flex: 0 0 200px;
          padding: 20px;
        }
      }
    }
  }
}
</style>
